import React from "react";
import { FileText, Eye, Download } from "lucide-react";
import { getDocumentMetadata, downloadDocument } from "../../../../utils/documentHelpers";

const DocumentCard = ({ doc, onView }) => {
  if (!doc) return null;

  const { name } = getDocumentMetadata(doc);

  return (
    <div className="flex items-center justify-between gap-2 p-2 rounded-lg bg-slate-50 border border-slate-200 text-xs font-medium text-slate-700">
      <div className="flex items-center gap-2 truncate max-w-[200px]" title={name}>
        <FileText className="w-4 h-4 text-blue-600 flex-shrink-0" />
        <span className="truncate">{name}</span>
      </div>

      <div className="flex items-center gap-1">
        {onView && (
          <button
            onClick={() => onView(doc)}
            className="p-1 text-slate-600 hover:text-blue-600 hover:bg-slate-200 rounded transition-colors"
            title="Preview Document"
          >
            <Eye className="w-3.5 h-3.5" />
          </button>
        )}
        <button
          onClick={() => downloadDocument(doc)}
          className="p-1 text-slate-600 hover:text-blue-600 hover:bg-slate-200 rounded transition-colors"
          title="Download Document"
        >
          <Download className="w-3.5 h-3.5" />
        </button>
      </div>
    </div>
  );
};

export default DocumentCard;
